<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <v-card>
                        <v-card-title>Buscar persona</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <PersonaBuscador v-model="form.dni" label="Ingrese el DNI de la persona"
                                        @personas:change="changePersona"></PersonaBuscador>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col v-if="personas.length > 1" cols="4">
                    <v-card>
                        <v-card-title>Personas</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="vista.hPersonas" :items="personas" class="elevation-1"
                                        hide-default-footer></v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col :cols="personas.length <= 1 ? '12':'8'">
                    <v-card>
                        <v-card-title>Causas</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table :headers="vista.hCausas" :items="causas" class="elevation-1"
                                        hide-default-footer></v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import PersonaBuscador from '../../components/persona/PersonaBuscador.vue'
import PersonaService from '../../services/Persona.service'
export default {
    components: { PersonaBuscador },
    data() {
        return {
            vista: {
                icono: "mdi-palette-swatch",
                titulo: "Consulta antecedentes",
                hPersonas: [
                    { text: 'Apellido', value: 'apellido' },
                    { text: 'Nombre', value: 'nombre' },
                    { text: 'Clase', value: 'clase' },
                ], 
                hCausas: [
                    { text: 'Fecha', value: 'fecha' },
                    { text: 'Causa', value: 'causa' },
                    { text: 'Dependencia', value: 'dependencia' },
                    { text: 'Interviniente', value: 'interviniente' },
                    { text: 'Sumario', value: 'sumario' },
                ],
            },
            personas: [],
            causas: [],
            form: {
                dni: 43925512,
            },

        }
    }, methods: {
        BuscarCausas(idProntuario) {
            PersonaService.ObtenerCausasPorIdProntuario(idProntuario)
                .then((res) => {
                    this.causas = res.data;
                })
                .catch((err) => {
                });
        },
        changePersona(value, event) {
            this.personas = value;
            this.BuscarCausas(this.personas[0].idProntuario);
        }
    },
}
</script>

<style scoped>
.inputNumber>>>input[type="number"] {
    -moz-appearance: textfield;
}

.inputNumber>>>input::-webkit-outer-spin-button,
.inputNumber>>>input::-webkit-inner-spin-button {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
}
</style>